import { Outlet } from "react-router-dom";
import globalStyles from "../../assets/styles/base/globalPage.module.scss";

export const TransactionsLayout = () => {
  return (
    <div className={`${globalStyles?.pagePaddings}`}>
      <Outlet />
    </div>
  );
};
